import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// ── Query key factories ──

export const itemKeys = {
  all: ["items"] as const,
  list: (filters: { search?: string; status?: string }) => ["items", "list", filters] as const,
  detail: (id: string) => ["items", "detail", id] as const,
};

export const userKeys = {
  all: ["users"] as const,
  list: (filters?: { search?: string }) => ["users", "list", filters] as const,
} as const;

export const devKeys = {
  seedAccounts: ["dev", "seed-accounts"] as const,
} as const;

export const emailKeys = {
  all: ["email"] as const,
  outbox: () => ["email", "outbox"] as const,
  templates: () => ["email", "templates"] as const,
  template: (key: string) => ["email", "templates", key] as const,
} as const;

export interface SkillFilters {
  search?: string;
  categories?: string[];
  risks?: string[];
  minRating?: number;
  freshness?: number;
  authors?: string[];
  sort?: string;
}

export const skillKeys = {
  all: ["skills"] as const,
  list: (filters: SkillFilters) => ["skills", "list", filters] as const,
  detail: (slug: string) => ["skills", "detail", slug] as const,
  mine: ["skills", "mine"] as const,
} as const;

export const analyticsKeys = {
  all: ["analytics"] as const,
} as const;

export const moderationKeys = {
  all: ["moderation"] as const,
} as const;
